import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPaintbrush24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconPaintbrush24"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Paintbrush24)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="m20.141 6.339-2.2 2.2-2.278-2.279 2.2-2.2a1.611 1.611 0 0 1 2.277 2.28m.04 4.439L19.001 9.6l2.2-2.2a3.111 3.111 0 1 0-4.4-4.4l-2.2 2.2-1.178-1.178a3 3 0 0 0-4.243 0L7.414 5.789a1.5 1.5 0 0 0-.379 1.485 2 2 0 0 0-.093.086l-4.478 4.478a1.5 1.5 0 0 0 0 2.122l7.778 7.778a1.5 1.5 0 0 0 2.121 0l4.479-4.479q.045-.044.085-.093a1.5 1.5 0 0 0 1.486-.378l1.768-1.768a3 3 0 0 0 0-4.242m-6.679-4.479.04-.039-1.179-1.178a1.5 1.5 0 0 0-2.121 0L8.474 6.849l.263.263q.176.1.327.248l7.778 7.778q.148.151.247.326l.263.263 1.768-1.767a1.5 1.5 0 0 0 0-2.122l-1.179-1.178-.039.039-1.06-1.06-2.279-2.279zM7.964 8.46l-4.44 4.439 1.16 1.159 1.964-1.964a.75.75 0 0 1 1.06 1.06l-1.964 1.964 1.14 1.14.864-.864a.75.75 0 0 1 1.06 1.06l-.864.864 1.14 1.14 2.513-2.515a.75.75 0 0 1 1.061 1.061l-2.514 2.514 1.159 1.159 4.439-4.439z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Paintbrush24">
                        <path fill="#fff" d="M0 0h24v24H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconPaintbrush24);
